export const allowedCountries = [
  'fr',
  'es',
  'pt',
  'en',
  'et',
  'fi',
  'el',
  'it',
  'lt',
  'nb',
  'br',
  'ru',
  'de',
  'hu',
  'sv',
] as const;

export type country = typeof allowedCountries[number];
